import type { MentionUser } from "./types";

interface AtMentionTagProps {
  user: MentionUser;
  onClick?: (user: MentionUser) => void;
  className?: string;
}

const baseClasses =
  "inline-flex items-center align-baseline bg-extended-pgasilver-brand-color text-extended-pgasilver-brand-on-color text-body-large leading-none rounded px-1 py-1";

export default function AtMentionTag({ user, onClick, className }: AtMentionTagProps) {
  const label = `@${[user.firstName, user.lastName].filter(Boolean).join(" ")}`;

  if (onClick) {
    return (
      <button
        type="button"
        onClick={() => onClick(user)}
        className={`${baseClasses} cursor-pointer hover:opacity-80 transition-opacity ${className ?? ""}`}
        data-testid="at-mention-tag"
      >
        {label}
      </button>
    );
  }

  return (
    <span className={`${baseClasses} ${className ?? ""}`} data-testid="at-mention-tag">
      {label}
    </span>
  );
}
